module.exports = __webpack_public_path__ + "img/swot-analysis.6c378f03.svg";